
import { Vue, Component } from "vue-property-decorator";
import auth from "@/services/auth";

import AuthCard from "@/components/auth/AuthCard.vue";
import AuthFormLink from "@/components/auth/AuthFormLink.vue";
import UiButton from '@/components/button/ui-button.vue';
import FormGroup from "@/components/form/FormGroup.vue";

import { NOTIFICATION } from "@/entities/Events";
import Message from '@/data/notificationsMessages';
import { parseConfirmationQuery } from "@/utils/parseConfirmationQuery";

@Component({
  components: {
    AuthCard,
    FormGroup,
    AuthFormLink,
    UiButton,
  },
})
export default class ForgotPasswordConfirm extends Vue {
  loading: boolean = false;

  username: string = "";
  code: string = "";
  password: string = "";
  confirmPassword: string = "";

  created(): void {
    const [username = "", confirmation_code] = parseConfirmationQuery(this.$route.query);
    this.username = (username as string).replace(" ", "+");
    this.code = confirmation_code as string;
  }

  async submit(): Promise<void> {
    this.loading = true;

    try {
      await auth.confirmForgotPassword(this.username, this.code, this.password);
      this.$eventBus.emit(
        NOTIFICATION,
        Message.successMessage("Password had been successfully changed."),
      );
    } catch (e) {
      this.$eventBus.emit(
        NOTIFICATION,
        Message.errorMessage(e.message),
      );
    } finally {
      this.loading = false;
    }
  }

  async resend(): Promise<void> {
    this.loading = true;

    try {
      await auth.forgotPassword(this.username);
      this.$eventBus.emit(
        NOTIFICATION,
        Message.successMessage("Sent."),
      );
    } catch (e) {
      this.$eventBus.emit(
        NOTIFICATION,
        Message.errorMessage(e.message),
      );
    } finally {
      this.loading = false;
    }
  }
}
